import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()((theme, { height, width, objectFit, aspectRatio })=>({
        img: {
            objectFit: objectFit,
            height: height,
            width: width
        },
        wrapper: {
            aspectRatio: aspectRatio
        }
    }));
export { useStyles };
